import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["value"]

import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ObjectDropdown',
  props: /*@__PURE__*/_mergeModels({
    items: { type: Array as PropType<T[]>, required: true },
    getDisplayText: { type: Function as PropType<(item: T) => string>, required: true },
    getKey: { type: Function as PropType<(item: T) => string | number>, required: false },
    isDisabled: { type: Boolean, default: false }
}, {
    "modelValue": { default: null },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel<T | null>(__props, "modelValue");





return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps({
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
  }, _ctx.$attrs, { disabled: __props.isDisabled }), [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
      return (_openBlock(), _createElementBlock("option", {
        key: __props.getKey ? __props.getKey(item) : i,
        value: item
      }, _toDisplayString(__props.getDisplayText(item)), 9, _hoisted_2))
    }), 128))
  ], 16, _hoisted_1)), [
    [_vModelSelect, model.value]
  ])
}
}

})